import { clearAuthData } from "utils/authUtils";
import api from "api";

const authActions = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  REFRESH_EXPIRATION: "REFRESH_EXPIRATION",

  login: data => {
    const expirationTime = new Date().getTime() + 2 * 60 * 60 * 1000; // 2 horas em milissegundos
    localStorage.setItem("tokenExpiration", expirationTime);
    localStorage.setItem("accessToken", data.token);

    return {
      type: authActions.LOGIN,
      isLogin: true,
      accessToken: data.token,
      email: data.email
    };
  },
  logout: () => async (dispatch, getState) => {
    const { auth } = getState();

    if (!auth.isLogin || !auth.accessToken) {
      return;
    }

    try {
      clearAuthData();

      dispatch({
        type: authActions.LOGOUT,
        isLogin: false,
        accessToken: null,
        email: null
      });

      await api.post(
        "/users/logout",
        {},
        {
          headers: { Authorization: `Bearer ${auth.accessToken}` },
          timeout: 5000
        }
      );

    } catch (error) {
      console.error("Erro ao fazer logout no backend:", error);
    } finally {
      window.location.href = "/login";
    }
  },
  refreshExpiration: () => {
    const newExpirationTime = new Date().getTime() + 2 * 60 * 60 * 1000;
    localStorage.setItem("tokenExpiration", newExpirationTime);

    return {
      type: authActions.REFRESH_EXPIRATION
    };
  }
};

export default authActions;
